/** "Where you can save" action list. */

import type { Flag, Subscription } from '../lib/types';
import { savingsFor, savingsReason } from '../model/savings';
import type { UsageStore } from '../model/usage';
import { el } from './dom';
import type { Formatters } from './format';

export function renderSavingsPanel(
  container: HTMLElement,
  active: Subscription[],
  usage: UsageStore,
  fmt: Formatters,
): void {
  const items: { sub: Subscription; savings: number; reason: string }[] = [];
  for (const sub of active) {
    const s = savingsFor(sub, usage);
    const reason = savingsReason(sub, usage);
    if (s > 0 && reason) items.push({ sub, savings: s, reason });
  }
  items.sort((a, b) => b.savings - a.savings);

  const advisories: { sub: Subscription; flag: Flag }[] = [];
  const seenOverlap = new Set<string>();
  for (const sub of active) {
    for (const flag of sub.flags) {
      if (flag.type === 'renewal-soon') advisories.push({ sub, flag });
      if (flag.type === 'overlap' && !seenOverlap.has(flag.detail)) {
        seenOverlap.add(flag.detail);
        advisories.push({ sub, flag });
      }
    }
  }

  if (!items.length && !advisories.length) {
    container.replaceChildren(
      el(
        'div',
        { class: 'empty-note' },
        "No obvious savings yet. Mark subscriptions you rarely or never use below and they'll show up here.",
      ),
    );
    return;
  }

  container.replaceChildren(
    ...items.map(({ sub, savings, reason }) =>
      el(
        'div',
        { class: 'save-item' },
        el('div', { class: 'save-amount' }, fmt.money(savings), el('span', {}, '/mo')),
        el(
          'div',
          { class: 'save-body' },
          el('div', { class: 'save-title' }, sub.name),
          el('div', { class: 'save-reason' }, reason),
        ),
      ),
    ),
    ...advisories.map(({ sub, flag }) =>
      el(
        'div',
        { class: 'save-item advisory' },
        el('div', { class: 'save-amount save-flag-icon' }, flag.type === 'renewal-soon' ? '⏰' : '⧉'),
        el(
          'div',
          { class: 'save-body' },
          el('div', { class: 'save-title' }, flag.type === 'renewal-soon' ? sub.name : flag.label),
          el('div', { class: 'save-reason' }, flag.detail),
        ),
      ),
    ),
  );
}
